<template>
    <div class="animated fadeIn">
        <div class="text-center" style="margin-top: 6rem">
            <img src="logo.png" />
            <h2 class="mt-3">We Serve & Do Better</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'landing-page',
    data() {
        return {

        }
    },
    mounted() {

        // Check token validity
        this.$axios.get("user/check")

    }
}
</script>
